<template>
  <div id="login">
    <h2>Login</h2>
    <span class="p-input-icon-left">
      <i class="pi pi-user" />
      <InputText type="text" v-model="email" placeholder="Email" />
    </span>
    <span class="p-input-icon-left">
      <i class="pi pi-lock" />
      <InputText type="password" v-model="password" placeholder="Password" />
    </span>
    <Button label="Log in" @click="loginUser()" icon="pi pi-sign-in" iconPos="right" />
    <br />
    <Toast position="bottom-center" />
  </div>
</template>

<script>
import { fb_auth } from "../firebase";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    loginUser() {
      if (this.email && this.password) {
        fb_auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            console.log("user:", fb_auth.currentUser);
            this.$router.push({ path: "/dashboard" });
            //route to dashboard
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: "errorcode",
              detail: "Login Message",
              life: 3000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Form Incomplete",
          detail: this.email
            ? "Password cannot be empty."
            : "Email cannot be empty",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;

}
</style>